import { render } from "./ApartmentsCompere.vue?vue&type=template&id=28baa483&scoped=true"
import script from "./ApartmentsCompere.vue?vue&type=script&lang=js"
export * from "./ApartmentsCompere.vue?vue&type=script&lang=js"

import "./ApartmentsCompere.vue?vue&type=style&index=0&id=28baa483&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28baa483"]])

export default __exports__